import axios from '@/libs/api.request'


/**
 * 国际化
 * @param params
 * @returns {never}
 */
export const getInternationality = (params) => {
  return axios.request({
    url: '/languageSetting/get',
    method: 'get',
    params: params
  })
}

export const postInternationality = (params) => {
  return axios.request({
    url: '/languageSetting/add',
    method: 'post',
    data: params
  })
}

